export function GenerateSourceUrlFromId(id: string) {
  return `https://content.parcelsolutions.net/42c5534b-0f47-4342-80f0-8f21203f0669/app/integrations/filter/${id}.svg`;
}

export function GenerateSourceUrl(source: { Id: string }) {
  return GenerateSourceUrlFromId(source.Id);
}

export function GenerateSourceSquareUrl(source: { Id: string }) {
  return GenerateSourceSquareUrlFromId(source.Id);
}

export function GenerateSourceSquareUrlFromId(id: string) {
  return `https://content.parcelsolutions.net//42c5534b-0f47-4342-80f0-8f21203f0669/integrations/marketplace/square/${id}.svg`;
}

export function GenerateSourceFullUrlFromId(id: string) {
  return `https://content.parcelsolutions.net//42c5534b-0f47-4342-80f0-8f21203f0669/integrations/marketplace/${id}.svg`;
}

export function GenerateSourceFullUrl(source: { Id: string }) {
  return GenerateSourceFullUrlFromId(source.Id);
}
